import React, { useEffect, useState } from 'react'
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { ComboBox, CommandBar, FontSizes, IComboBox, IComboBoxOption, IComboBoxStyles, ICommandBarItemProps, Panel, PanelType, TextField } from '@fluentui/react';
import TokenService from '../../../services/Authentication/TokenService';
import { urlTelerik } from '../../../services/http-common';
import themeBase from '../../../utils/theme/themeBase';
import { IExportarReporte, IParametro } from '../../../Interfaces/base/IBase';
import reporteServicio from '../../../services/reporteService';
import IconHelper from '../../../utils/helpers/iconHelper';
import { useBoolean } from "@fluentui/react-hooks";
import { PanelGenerico } from '../../../components/generic/PanelGenerico';
import { Text } from '@fluentui/react/lib/Text';

export interface ITabletsAsignados {
    // isOpen: boolean;
    // onDismiss: () => void;
    reportName: string,
    parametros: {} | undefined,
    formatos?: number,
    viewMode?: string
    // reload: () => void;
}

export interface IGuardia {
    Guardia: string
}

const comboBoxStyles: Partial<IComboBoxStyles> = { root: { maxWidth: 300 } };

export const TabletsAsignados = (props: ITabletsAsignados) => {

    const { reportName, parametros, formatos = 1, viewMode } = props; // Asignar valor por defecto directamente aquí
    const [currentFormatos, setCurrentFormatos] = useState(formatos);
    const [currentViewMode, setViewMode] = useState(viewMode);

    const [guardiaAux, setGuardiaAux] = useState("");
    const [filtroGuardia, setFiltroGuardia] = useState<IGuardia>({ Guardia: "A,B,C,D" });
    const [openPanel, setOpenPanel] = useState(false);

    const options: IComboBoxOption[] = [
        { key: 'A', text: 'Guardia A' },
        { key: 'B', text: 'Guardia B' },
        { key: 'C', text: 'Guardia C' },
        { key: 'D', text: 'Guardia D' },
    ];

    const [
        isOpenPanelFiltro,
        { setTrue: openPanelFiltro, setFalse: dismissPanelFiltro },
    ] = useBoolean(false);

    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        setCurrentFormatos(formatos);
    }, [formatos]);
    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        setViewMode(viewMode);
    }, [viewMode]);

    // useEffect(() => {
    //     console.log("Formatos:", currentFormatos);
    // }, [currentFormatos]);

    let t = TokenService.getToken();
    let viewerRef;
    const urlTelerikR = `${urlTelerik}/reports`;

    const [key, setKey] = useState(0);

    const [selectedKeys, setSelectedKeys] = React.useState<string[]>(["A", "B", "C", "D"]);

    const _onChangEquipo = (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption
    ) => {
        if (event !== undefined) {
            if (option) {
                let data = (prevSelectedKeys: any[]) =>
                    option.selected
                        ? [...prevSelectedKeys, option!.key as string]
                        : prevSelectedKeys.filter((k) => k !== option!.key);
                setSelectedKeys(data);
            }
        }
    };

    const viewerOptions = {
        serviceUrl: urlTelerikR,
        reportSource: {
            report: props.reportName,
            parametros: props.parametros
            //parameters: { "editors": { "multiSelect": { "listaVerificacionId": "50884d84-fd34-43ff-9686-179542b5a7aa" } } },
        },
        viewerContainerStyle: themeBase.telerikStyleV2,
        // viewerContainerStyle: viewerContainerStyle,
        // viewMode: currentViewMode,
        viewMode: 'PRINT_PREVIEW',
        scaleMode: 'FIT_PAGE_WIDTH',
        // scaleMode: 'SPECIFIC',
        scale: 1.0,
        enableAccessibility: false,
        toolbar: {
            items: [
                {
                    type: 'togglePrintPreview',
                    text: 'Print',
                    visible: true
                },
                {
                    type: 'export',
                    text: 'Export',
                    visible: false
                }
            ]
        },
        authenticationToken: t,
        // ready: function () {
        //   //this.refreshReport();
        // }

    };

    const transformarParametros = (parametros: IGuardia): IParametro[] => {
        return Object.entries(parametros).map(([key, value]) => ({
            Key: key,
            Value: value,
        }));
    };

    function descargarReporte(extension: string) {
        const reporteExportar: IExportarReporte = {
            report: props.reportName,
            Extension: extension,
            //Parametros: [{ filtroGuardia }]
        }
        reporteExportar.Parametros = transformarParametros(filtroGuardia);

        reporteServicio.exportaReporte(reporteExportar)
            .then((response) => {
                if (response.status === 200) {
                    // response.json().then((data) => {
                    //   console.log("Datos de la respuesta:", data);
                    // });
                    //   console.log("Datos de la respuesta: Reporte generado ----");
                    //   console.log(response.data);

                    const dataUrl = response.data;

                    // Create a link element
                    const link = document.createElement('a');
                    link.href = dataUrl;
                    link.download = 'reporte'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

                    // Simulate a click on the link to trigger the download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                }
                else {
                    console.error("Status:", response.status);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    // Función para recargar el componente
    const recargarComponente = () => {
        setKey(prevKey => prevKey + 1);
    };

    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            // onClick: (arg) => actualizarTabla(),
            // onClick: () => viewerRef.refreshReport(),
            onClick: recargarComponente,
        }
    ];

    const getFarItems = () => {
        if (currentFormatos === 1) {
            return [
                {
                    ...IconHelper.ICON_PDF,
                    onClick: () => {
                        descargarReporte("PDF");
                    },
                },
                {
                    ...IconHelper.ICON_FILTER,
                    onClick: () => {
                        openPanelFiltro();
                    },
                }
            ];
        } else if (currentFormatos === 2) {
            return [
                {
                    ...IconHelper.ICON_PDF,
                    onClick: () => {
                        descargarReporte("PDF");
                    },
                },
                {
                    ...IconHelper.ICON_EXCEL,
                    onClick: () => {
                        descargarReporte("XLSX");
                    },
                },
                {
                    ...IconHelper.ICON_FILTER,
                    onClick: () => {
                        openPanelFiltro();
                    },
                }
            ];
        } else {
            return [];
        }
    };

    const _farItems: ICommandBarItemProps[] = getFarItems();


    // const _farItems: ICommandBarItemProps[] = [
    //     {
    //         ...IconHelper.ICON_PDF,
    //         onClick: () => {
    //             descargarReporte("PDF");
    //         },
    //     },
    //     {
    //         ...IconHelper.ICON_EXCEL,
    //         onClick: () => {
    //             descargarReporte("XLSX");
    //         },
    //     }
    // ];

    useEffect(() => {
        const hideExportButton = () => {
            const exportButton: any = document.querySelector("#trv-main-menu-export-command");
            // console.log(exportButton)

            if (exportButton) {
                // console.log(exportButton)
                exportButton.remove();
                // exportButton.style.display = 'none';
                clearInterval(interval);
            }
        };

        // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
        const interval = setInterval(hideExportButton, 1);

        // Limpia el intervalo al desmontar el componente
        return () => clearInterval(interval);
    }, [key]);


    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        // recargarComponente();
        viewerRef.refreshReport()
    }, [props.reportName]);

    const _back = () => {
        setFiltroGuardia({ ...filtroGuardia, Guardia: "A,B,C,D" })
        setSelectedKeys(["A", "B", "C", "D"]);
        setKey(prevKey => prevKey + 1);
        dismissPanelFiltro();
    };

    const _closePanel = () => {
        dismissPanelFiltro();
    };

    // const _onChangeText = (
    //     type: string,
    //     event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    //     newValue?: string
    // ) => {
    //     if (event !== undefined) {
    //         if (newValue !== undefined) {
    //             switch (type) {
    //                 case "guardia":
    //                     setGuardiaAux(newValue)
    //                     break;
    //                 default:
    //                     setGuardiaAux("A,B,C,D")
    //                     break;
    //             }
    //             console.log(newValue);
    //         }
    //     }
    // };


    const changeFilter = () => {
        // setFiltroGuardia({
        //     ...filtroGuardia,
        //     Guardia: guardiaAux
        // })
        setFiltroGuardia({
            ...filtroGuardia,
            Guardia: selectedKeys.join(",")
        })
        setKey(prevKey => prevKey + 1);
        setGuardiaAux("")
        dismissPanelFiltro()
    };

    return (
        <>
            {/* <div>BaseReportesTelerik</div>
            <pre>{JSON.stringify("--------exsisteExperiencias---", null, 2)}</pre>
            <pre>{JSON.stringify(currentFormatos, null, 2)}</pre>
            <pre>{JSON.stringify("--------exsisteExperiencias---", null, 2)}</pre>
            <pre>{JSON.stringify(filtroGuardia, null, 2)}</pre> */}
            <div className="ms-Grid-col ms-sm12 ms-lg12">
                <CommandBar
                    items={_items}
                    farItems={_farItems}
                    styles={themeBase.commadStyles}
                />
            </div>
            <PanelGenerico
                HeaderTitlesText={
                    {
                        title: "Filtros",
                        // subTitle2: filtroGuardia.Guardia
                        //subTitle2: `Filto aplicado: ${filtroGuardia.Guardia}`
                    }}
                enabledHeader
                isOpen={isOpenPanelFiltro}
                onDismiss={_closePanel}
                panelType={PanelType.smallFixedFar}
                cancelar={_back}
                //objectRenderBodyHelp={{ ...form, val: equal }}
                //disabledRegister={disableForm}
                textRegister='Filtrar'
                textCancel='Limpiar filtro'
                registrar={changeFilter}
            >
                <div>
                    <div key={filtroGuardia.Guardia}
                        style={{ fontSize: FontSizes.size10 }}
                    >
                        <Text
                            style={{ fontSize: FontSizes.size10, color: '#626264' }}
                        // nowrap block
                        >
                            <span style={{ marginRight: '8px' }}>✓</span>
                            {`Guardia: ${filtroGuardia.Guardia}`
                            }
                        </Text>
                    </div>
                    <br />
                    {/* <TextField
                        className="custom-placeholder"
                        // className="customStyles"
                        label="Guardia:"
                        placeholder="A,B,C,D"
                        onChange={(e, o) => _onChangeText("guardia", e, o)}
                        autoComplete="on"
                        type="text"
                        description="Filtro por defecto A,B,C,D"
                    /> */}
                    <ComboBox
                        // defaultSelectedKey="A"
                        label="Seleccione una o más guardias:"
                        multiSelect
                        selectedKey={selectedKeys}
                        options={options}
                        styles={comboBoxStyles}
                        onChange={_onChangEquipo}
                    />
                </div>
            </PanelGenerico>

            <div key={key}
                style={{
                    // border: '5px solid red',
                    width: '100%',
                    height: 'auto'
                }}
            >
                <TelerikReportViewer
                    ref={el => viewerRef = el}
                    serviceUrl={viewerOptions.serviceUrl}
                    reportSource={{
                        report: viewerOptions.reportSource.report,
                        parameters: filtroGuardia
                    }}
                    //viewerContainerStyle={viewerOptions.viewerContainerStyle}
                    viewerContainerStyle={viewerOptions.viewerContainerStyle}
                    parametersAreaVisible={true}
                    viewMode={viewerOptions.viewMode}
                    scaleMode={viewerOptions.scaleMode}
                    scale={viewerOptions.scale}
                    enableAccessibility={viewerOptions.enableAccessibility}
                    authenticationToken={viewerOptions.authenticationToken}
                    toolbarItems={viewerOptions.toolbar.items}
                    skipBlankPages={false}
                />
            </div>
        </>
    )
}
